import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_LOAD_GRAPH } from './url-constants';

type LoadGraphEndpointSpecification = ApiEndpointSpecification;
export const LoadGraphEndpointSpecification: LoadGraphEndpointSpecification = {
    url: DEVICE_LOAD_GRAPH,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'LoadGraphRequestParams',
    requestBodySchemaName: 'LoadGraphRequestBody',
    okResponseSchemaName: 'LoadGraphOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2,
};

export const invokeLoadGraphData = Helpers.makeApiRequestFn<
    Types.LoadGraphRequestParams,
    Types.LoadGraphRequestBody,
    Types.LoadGraphOkresponse
>(LoadGraphEndpointSpecification);
